import React, {ReactNode} from 'react';
import {Trans} from '@lingui/react';

import StatusToggle from 'shared/ui/StatusToggle/StatusToggle';

import styles from './MonitorToggle.module.scss';

interface IMonitorToggleProps {
    isBatchMode: boolean;
    handleModeToggle: () => void;
    label?: ReactNode;
    hint?: string;
}

const MonitorToggle: React.FC<IMonitorToggleProps> = ({isBatchMode, handleModeToggle, label, hint}) => {
    return (
        <div className={styles.container}>
            <span className={styles.text}>
                {label ?? <Trans id="add.monitor.modal.toggle.title" message="URL сайта"/>}
            </span>
            <StatusToggle
                condition={isBatchMode}
                onClick={handleModeToggle}
                isMonitor
                massAddHint={hint}
            />
        </div>
    );
};

export default MonitorToggle;
